module.exports = "<div class=\"entire-primary-header component-page-header\">\n  <h1>{{title}}</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/layout/content-header/content-header.component.html
// module id = ../../../../../src/app/layout/content-header/content-header.component.html
// module chunks = main